import { useEffect, useState } from 'react'

/**
 * Följer en CSS-media query från React.
 *
 * Finns för de fall där skillnaden mellan smal och bred skärm inte bara är
 * utseende utan innebörd. Leaderboarden är ett sådant: på bred skärm står
 * lagen alltid utfällda, och då ska raden inte vara en knapp som påstår sig
 * kunna fälla ihop dem. Ren CSS hade dolt chevronen men lämnat kvar
 * knappsemantiken för den som lyssnar i stället för tittar.
 *
 * Initialvärdet läses direkt ur matchMedia, så första renderingen är rätt och
 * inte ett hopp från false.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = () => setMatches(mq.matches)
    // Läs om direkt: mellan useState-initialiseringen och den här effekten
    // kan skärmen ha ändrats, och då hade lyssnaren aldrig fått veta det.
    setMatches(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])

  return matches
}
